@if (parentElement && elements?.length) {
  <nav class="navbar navbar-expand p-0 bg-white shadow-sm mw-xs-xl-1280p" role="navigation">
    <div class="container-fluid px-3">
      <div class="collapse navbar-collapse px-md-3">
        @if (showOrderListsViewTypeSwitch()) {
          <app-order-lists-view-type-switch />
        }

        <ul class="navbar-nav nav-pills nav flex-grow-1">
          @for (element of elements; track element.id) {
            <li class="nav-item">
              @if (element.isDropdown) {
                <a class="btn nav-link no-outline"
                  [class.active]="element === selectedElement"
                  (click)="onDropdownClick(element, $event)"
                >
                  {{ element.title | translate }}
                </a>
              }
              @else if (element.externalPathTarget?.length) {
                <a class="btn nav-link no-outline"
                  [href]="element.externalPath"
                  [target]="element.externalPathTarget ?? '_self'"
                  [class.active]="element === selectedElement"
                  (click)="onNavbarClose()"
                >
                  {{ element.title | translate }}
                </a>
              }
              @else if (isEstimatesElement(element)) {
                <a class="btn nav-link no-outline"
                  [routerLink]="estimatesLink"
                  [class.active]="element === selectedElement"
                  (click)="onNavbarClose()"
                  #estimatesIntroPopover="ngbPopover"
                  [ngbPopover]="estimatesIntroContent"
                  [animation]="false"
                  placement="bottom"
                  [autoClose]="false"
                  popoverClass="mw-100 rounded-1 shadow-sm"
                  container="body"
                  triggers="manual"
                >
                  {{ element.title | translate }}
                </a>
              }
              @else {
                <a class="btn nav-link no-outline"
                  [routerLink]="`${topLevelUrlPath}/${element.path}`"
                  [class.active]="element === selectedElement"
                  (click)="onNavbarClose()"
                >
                  {{ element.title | translate }}
                </a>
              }
            </li>
          }
        </ul>
        @if (showSearch()) {
          <app-navigation-search-input />
        }
      </div>
    </div>
  </nav>
}

<ng-template #estimatesIntroContent>
  <div class="d-flex flex-column gap-3" [style.width.px]="248" data-testid="estimatesIntro">
    <div class="d-grid gap-3 lh-1.25rem" [innerHTML]="'CUSTOM_MADE_PRICE_ESTIMATES.INTRO_NOTE' | translate"></div>
    <div class="d-flex gap-2">
      <button type="button" class="btn flex-fill" (click)="dismissEstimatesIntro()" data-testid="closeEstimatesIntro">
        {{ 'CUSTOM_MADE_PRICE_ESTIMATES.INTRO_CLOSE' | translate }}
      </button>
      <a class="btn btn-primary flex-fill" [routerLink]="estimatesLink" data-testid="tryEstimates">
        {{ 'CUSTOM_MADE_PRICE_ESTIMATES.TRY_NOW' | translate }}
      </a>
    </div>
  </div>
</ng-template>
